import type { VariableConfig } from "../fields/types";
import FieldValueReference from "../fields/FieldValueReference";
import VariableValueReference from "../variables/VariableValueReference";

export const createReference = (value: string, variables: VariableConfig[]) =>
  variables.some((variable) => variable.uid.equals(value))
    ? VariableValueReference.from(value)
    : FieldValueReference.from(value);

export const toVariableMap = (variables: VariableConfig[]) =>
  variables.reduce((acc, variable) => {
    acc.set(variable.uid.toString(), variable);
    return acc;
  }, new Map<string, VariableConfig>());
